module.exports = __webpack_public_path__ + "static/second_user_image4-f7d1a583ff4b8ad3cff92158e7b8c0f7.jpg";